import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import PrismicVue from 'prismic-vue'
import linkResolver from './prismic/link-resolver'
import htmlSerializer from './prismic/html-serializer'

import underscore from 'vue-underscore';

import VueWait from 'vue-wait'

import vueVimeoPlayer from 'vue-vimeo-player'

import VueTippy, { TippyComponent } from "vue-tippy";

import MarqueeText from 'vue-marquee-text-component'

import VueYoutube from 'vue-youtube'

import LazyLoadDirective from "./directives/LazyLoadDirective";

import VueGtag from "vue-gtag";

import VueMeta from 'vue-meta'

Vue.use(VueMeta)

Vue.use(VueGtag, {
  config: { id: "G-D75QLNZ9J0" }
});

Vue.directive("lazyload", LazyLoadDirective);

Vue.use(VueYoutube)

Vue.component('marquee-text', MarqueeText)

Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

Vue.use(VueWait)

Vue.use(vueVimeoPlayer)

Vue.use(underscore)

Vue.config.productionTip = false

Vue.use(PrismicVue, {
  endpoint: window.prismic.endpoint,
  linkResolver,
  htmlSerializer
})

new Vue({
  router,
  store,
  wait: new VueWait({
    useVuex: true
  }),
  render: function (h) { return h(App) }
}).$mount('#app')
